export default "__VITE_ASSET__d4f003bc__"